import React, { createContext, useContext, useState } from 'react';

const CatalogProductsContext = createContext();

export function CatalogProductsProvider({ children }) {
  // Guarda productos y la marca de tiempo
  const [products, setProducts] = useState([]);
  const [lastFetched, setLastFetched] = useState(null);

  const saveProducts = (newProducts) => {
    setProducts(newProducts);
    setLastFetched(Date.now());
  };

  return (
    <CatalogProductsContext.Provider value={{ products, saveProducts, lastFetched }}>
      {children}
    </CatalogProductsContext.Provider>
  );
}

export function useCatalogProducts() {
  return useContext(CatalogProductsContext);
}
